/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      // DASHBOARDS
      {title: "Əsas səhifə",                 url: "/dashboard",                icon: "HomeIcon",           is_bookmarked: false},
      {title: "Bələdiyyə",                   url: "/municipalities",           icon: "ClipboardIcon",          is_bookmarked: false},
      {title: "Terminallar",                 url: "/terminals",                icon: "TerminalIcon",           is_bookmarked: false},
      {title: "Qrup Ödəniş statistikası",    url: "/group-payment-statistics",                icon: "FilterIcon",           is_bookmarked: false},
      {title: "Ətraflı Ödəniş statistikası", url: "/details-payment-statistics",                icon: "FilterIcon",           is_bookmarked: false},
      {title: "Ödənişin qəbulu",             url: "/payments",                icon: "HomeIcon",           is_bookmarked: false},
    ]
  },
  files: {
    key:"file_name",
    data: [
      // { file_name: "Joe's CV",         from:"Stacy Watson",    file_ext:"doc", size:"1.7 mb"  },
    ]
  },
  contacts: {
    key:"name",
    data: [
      // { img: require("@/assets/images/portrait/small/avatar-s-1.jpg"),  name: "Rena Brant",          email: "nephrod@preany.co.uk",     time: "21/05/2019" },
    ]
  },
}
/* eslint-enable */
